import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { InterceptorService } from './services/interceptor.service';
import { LoaderComponent } from './shared/loader/loader.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';
import { LoginComponent } from './Components/auth/login.component';
import { LandingComponent } from './Components/landing-page/landing.component';
import { DataService } from './services/data.service';
import { ApiService } from './services/api.service';
import { UtilService } from './services/util.service';
import { ButtonModule } from 'primeng/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogModule } from 'primeng/dialog';
import { SliderModule } from 'primeng/slider';
import { CalendarModule } from 'primeng/calendar';
import { ToasterComponent } from './shared/toaster/toaster.component';
import { InstitutesComponent } from './Components/institutes/institutes.component';
import { CoursesComponent } from './Components/courses/courses.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoanDetailsComponent } from './Components/loan-details/loan-details.component';
import { StudentDetailsComponent } from './Components/student-details/student-details.component';
import { KycComponent } from './Components/kyc/kyc.component';
import { PanDetailsComponent } from './Components/kyc/pan-details/pan-details.component';
import { BasicDetailsComponent } from './Components/kyc/basic-details/basic-details.component';
import { EmploymentDetailsComponent } from './Components/kyc/employment-details/employment-details.component';
import { DialogBoxComponent } from './shared/dialog-box/dialog-box.component';
import { ProofVerificationComponent } from './Components/proof-verification/proof-verification.component';
import { BankDetailsComponent } from './Components/proof-verification/bank-details/bank-details.component';
import { AadharDetailsComponent } from './Components/proof-verification/aadhar-details/aadhar-details.component';
import { SelfieComponent } from './Components/proof-verification/selfie/selfie.component';
import { KeyFactStatementComponent } from './Components/key-fact-statement/key-fact-statement.component';
import { DatePipe } from '@angular/common';
import { EmailVerificationComponent } from './Components/email-verification/email-verification.component';
import { ApplicationLetterComponent } from './Components/application-letter/application-letter.component';
import { NachMandateComponent } from './Components/nach-mandate/nach-mandate.component';
import { WelcomeComponent } from './Components/welcome/welcome.component';
import { SnackbarComponent } from './Components/snackbar/snackbar.component';
import { DateFormatDirectiveDirective } from './directives/date-format-directive.directive';
import { RestrictSpecialCharsDirective } from './directives/restrict-special-chars.directive';
import { MoratoriumComponent } from './Components/moratorium/moratorium.component';
import { InsuranceComponent } from './Components/insurance/insurance.component';
import { GrievanceRedressalComponent } from './Components/grievance-redressal/grievance-redressal.component';
import { FaqComponent } from './Components/faq/faq.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { EmiCalculatorComponent } from './Components/emi-calculator/emi-calculator.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PanValidatiorDirective } from './directives/pan-validatior.directive';
import { EligibilityComponent } from './Components/eligibility/eligibility.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { TermsComponent } from './Components/eligibility/terms/terms.component';
import { AccountAggregatorComponent } from './Components/account-aggregator/account-aggregator.component';
import { IFSCCODEValidation } from './directives/filter-alphanumeric-directive.directive';
import { AllowOnlyNumberDirective } from './directives/allow-only-number.directive';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}
import { WebcamModule } from 'ngx-webcam';
import { CameraComponent } from './Components/proof-verification/selfie/camera/camera.component';
import { DigilockerComponent } from './Components/proof-verification/aadhar-details/digilocker/digilocker.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { WaitingScreenComponent } from './Components/waiting-screen/waiting-screen.component';
import { ProcessingFeeComponent } from './Components/processing-fee/processing-fee.component';
import { NoResultsComponent } from './Components/no-results/no-results.component';
import { EsignWebViewComponent } from './Components/application-letter/esign-web-view/esign-web-view.component';
import { PNachComponent } from './Components/nach-mandate/p-nach/p-nach.component';
import { PrivacyComponent } from './Components/privacy/privacy.component';
import { DateComponent } from './shared/date/date.component';
import { HomeComponent } from './Components/landing-page/home/home.component';
import { CarouselModule } from 'primeng/carousel';
import { KycDetailsComponent } from './Components/kyc-details/kyc-details.component';
import { AfterSanctionComponent } from './Components/after-sanction/after-sanction.component';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    HeaderComponent,
    FooterComponent,
    LandingComponent,
    LoginComponent,
    ToasterComponent,
    InstitutesComponent,
    CoursesComponent,
    LoanDetailsComponent,
    StudentDetailsComponent,
    KycComponent,
    PanDetailsComponent,
    BasicDetailsComponent,
    EmploymentDetailsComponent,
    DialogBoxComponent,
    ProofVerificationComponent,
    BankDetailsComponent,
    AadharDetailsComponent,
    SelfieComponent,
    KeyFactStatementComponent,
    EmailVerificationComponent,
    ApplicationLetterComponent,
    NachMandateComponent,
    WelcomeComponent,
    SnackbarComponent,
    DateFormatDirectiveDirective,
    RestrictSpecialCharsDirective,
    MoratoriumComponent,
    InsuranceComponent,
    GrievanceRedressalComponent,
    FaqComponent,
    ContactUsComponent,
    EmiCalculatorComponent,
    PanValidatiorDirective,
    EligibilityComponent,
    TermsComponent,
    CameraComponent,
    DigilockerComponent,
    AccountAggregatorComponent,
    IFSCCODEValidation,
    AllowOnlyNumberDirective,
    WaitingScreenComponent,
    ProcessingFeeComponent,
    NoResultsComponent,
    EsignWebViewComponent,
    PNachComponent,
    PrivacyComponent,
    DateComponent,
    HomeComponent,
    KycDetailsComponent,
    AfterSanctionComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    ReactiveFormsModule,
    SliderModule,
    CalendarModule,
    AutoCompleteModule,
    LottieModule.forRoot({ player: playerFactory }),
    WebcamModule,
    PdfViewerModule,
    CarouselModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  exports: [
    HeaderComponent,
    FooterComponent
  ],
  providers: [DataService, ApiService,DatePipe, UtilService, {
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorService,
    multi: true
  }],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
